// Number and date formatting shared by the page. All dates are rendered in UTC.

export const fmtUsd = (v: number, digits: number): string =>
  v.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });

/** "3 d 2 h 5 min", "2 h 5 min" or "5 min" for a duration in milliseconds (never negative). */
export function dur(ms: number): string {
  const m = Math.max(0, Math.floor(ms / 60000));
  const d = Math.floor(m / 1440);
  const h = Math.floor((m % 1440) / 60);
  const mm = m % 60;
  return d > 0 ? `${d} d ${h} h ${mm} min` : h > 0 ? `${h} h ${mm} min` : `${mm} min`;
}

/** "2026-09-08 13:30 UTC" */
export const fmtUtc = (d: Date): string => d.toISOString().replace('T', ' ').slice(0, 16) + ' UTC';
/** "13:30:05 UTC" */
export const fmtUtcS = (d: Date): string => d.toISOString().replace('T', ' ').slice(11, 19) + ' UTC';
/** "Monday" */
export const dayName = (d: Date): string => d.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });
/** "0x574cB8…17114f" */
export const short = (a: string): string => a.slice(0, 8) + '…' + a.slice(-6);
/** Fee units to "5,000 (0.50 %)". */
export const feeText = (units: number): string => `${units.toLocaleString('en-US')} (${(units / 10000).toFixed(2)} %)`;

/** A timestamp from the API as a Date; null or an empty string is no date, never 1970-01-01. */
export function parseTs(s: string | number | null | undefined): Date | null {
  if (s == null || s === '') return null;
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "2026-09-06 22:00" from "2026-09-06T22:00Z" (the snapshot's own notation). */
export const snapDay = (s: string): string => s.replace('T', ' ').replace('Z', '');

export function sharesPerToken(m: bigint): string {
  if (m === 0n) return '0 (not set)';
  const v = Number(m) / 1e18;
  return `${v.toLocaleString('en-US', { maximumFractionDigits: 6 })} ${v === 1 ? 'share' : 'shares'} per token`;
}

/** Signed percentage with two decimals: "+0.93 %" */
export const signedPct = (v: number): string => (v >= 0 ? '+' : '') + v.toFixed(2) + ' %';

export const errorText = (e: unknown): string =>
  e instanceof Error ? e.message : typeof e === 'string' ? e : String(e);
